import { Menu } from "antd";
import React, { useEffect, useState } from "react";
import {
  UserOutlined,
  LockOutlined,
  BankOutlined,
  ControlOutlined,
  FileDoneOutlined,
  DashboardOutlined,
  TeamOutlined,
  HomeOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

const paths = [
  { path: "/setup-account/overview", key: "1" },
  { path: "/setup-account/general", key: "2" },
  { path: "/setup-account/general/org-levels", key: "2" },
  { path: "/setup-account/general/plan-templates", key: "2" },
  { path: "/setup-account/general/plan-groups", key: "2" },
  { path: "/setup-account/general/designations", key: "2" },
  { path: "/setup-account/general/plan-attributes", key: "2" },
  { path: "/setup-account/general/scales", key: "2" },
  { path: "/setup-account/organization", key: "3" },
  { path: "/setup-account/unit", key: "3" },
  { path: "/setup-account/positions", key: "4" },
  { path: "/setup-account/users", key: "5" },
  { path: "/setup-account/perf-cycles", key: "6" },
  { path: "/setup-account/approvals", key: "7" },
  { path: "/setup-account/user-profile", key: "11" },
  { path: "/setup-account/change-password", key: "12" },
];

function SetupSideMenu(props) {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  let curLocation = useLocation();

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[2] === "unit") {
        setMainKey("3");
      } else if (curLocation.pathname.split("/")[3] === "plan-templates") {
        setMainKey("2");
      }
    });
  }, [curLocation]);

  return (
    <>
      <Menu
        style={{
          height: proHeight - 142,
          overflow: "auto",
          marginTop: "20px",
        }}
        className="transparent-scroll"
        theme="dark"
        selectedKeys={[mainKey]}
        mode="inline"
      >
        <Menu.Item key="1" icon={<HomeOutlined />}>
          <Link to="/setup-account/overview">Overview</Link>
        </Menu.Item>
        <div
          className={
            "text-xs text-white mt-6 " +
            (props.collapsed ? "text-center" : "pl-6")
          }
        >
          Org
          <span style={{ display: props.collapsed && "none" }}>anization</span>
        </div>
        <Menu.Item key="2" icon={<ControlOutlined />}>
          <Link to="/setup-account/general/org-levels">General</Link>
        </Menu.Item>
        <Menu.Item key="3" icon={<BankOutlined />}>
          <Link to="/setup-account/organization">Organization</Link>
        </Menu.Item>
        <Menu.Item key="4" icon={<IdcardOutlined />}>
          <Link to="/setup-account/positions">Positions</Link>
        </Menu.Item>
        <Menu.Item key="5" icon={<TeamOutlined />}>
          <Link to="/setup-account/users">Users</Link>
        </Menu.Item>
        <Menu.Item key="6" icon={<DashboardOutlined />}>
          <Link to="/setup-account/perf-cycles">Perf cycles</Link>
        </Menu.Item>
        <Menu.Item key="7" icon={<FileDoneOutlined />}>
          <Link to="/setup-account/approvals">Approvals</Link>
        </Menu.Item>
        <div
          className={
            "text-xs text-white mt-6 " +
            (props.collapsed ? "text-center" : "pl-6")
          }
        >
          Pers<span style={{ display: props.collapsed && "none" }}>onal</span>
        </div>
        <Menu.Item key="11" icon={<UserOutlined />}>
          <Link to="/setup-account/user-profile">Your Profile</Link>
        </Menu.Item>
        <Menu.Item key="12" icon={<LockOutlined />}>
          <Link to="/setup-account/change-password">Change Password</Link>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default SetupSideMenu;
